export const PaperAndPencilIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M17.9091 3.48516H18.8182C20.5755 3.48516 22 4.89663 22 6.63776L21.9996 18.7978M5.86364 8.43925H2V21.5H18.8182C20.5755 21.5 22 20.0885 22 18.3474C22 16.6063 20.5755 15.1948 18.8182 15.1948H17.4545L17.4541 3.48516M12.4545 8.43925H17.4545M9.27246 12.4928L12.9088 10.241M4.125 5.00919L9.18974 13.701L13.3635 15.6453L13.5759 11.1919L8.5112 2.50008L4.125 5.00919Z" />
    </svg>
  );
};
